import React, { useEffect } from "react";
import clsx from "clsx";

interface IListBoxOptions {
	id: string;
	name: string;
}

interface IListBoxProps {
	options: IListBoxOptions[];
	selectedOption: IListBoxOptions | null;
	onSelect: (option: IListBoxOptions) => void;
	style?: React.CSSProperties | undefined;
}

const ListBox: React.FC<IListBoxProps> = ({
	options,
	selectedOption,
	onSelect,
	style,
}) => {
	const handleSelect = (option: IListBoxOptions) => {
		onSelect(option);
	};

	return (
		<div
			style={{
				...style,
				overflowY: "scroll",
				overflowX: "hidden",
				border: "1px solid #d9d9d9",
				borderRadius: 4,
				maxWidth: "100%",
			}}
		>
			{options.map((option) => (
				<div
					key={option.id}
					onClick={() => handleSelect(option)}
					style={{
						marginRight: 8,
						fontWeight: option === selectedOption ? "bold" : "normal",
						backgroundColor:
							option === selectedOption ? "#4252FF" : "transparent",
						color: option === selectedOption ? "white" : "black",
						cursor: "pointer",
						whiteSpace: "nowrap",
						width: "100%",
					}}
					onMouseEnter={(e) => {
						if (option !== selectedOption) {
							e.currentTarget.style.backgroundColor = "#f0f0f0";
						}
					}}
					onMouseLeave={(e) => {
						if (option !== selectedOption) {
							e.currentTarget.style.backgroundColor = "transparent";
						}
					}}
				>
					{option.name}
				</div>
			))}
		</div>
	);
};

export default ListBox;
